module.exports = __webpack_public_path__ + "static/FloatingFile-3-light-e2cd0ca1cf5e6fbebd9cb27ce9998867.svg";